export default __webpack_public_path__ + "static/media/logout.08abecf4.svg";